import { render, staticRenderFns } from "./ViewEquipmentPage.vue?vue&type=template&id=5d6ffc3c"
import script from "./ViewEquipmentPage.vue?vue&type=script&lang=js"
export * from "./ViewEquipmentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports